import {queryOptions, useQuery} from '@tanstack/react-query';
import {GetExamsPreparationParams} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getExamsPreparation} from '../../services/getExamsPreparation';

export const examsPreparationQueryOptions = ({
	cdTipoExame,
	nuIdade,
}: Pick<GetExamsPreparationParams, 'cdTipoExame' | 'nuIdade'>) =>
	queryOptions({
		queryKey: [QUERY_KEYS.EXAMS_PREPARATION, {cdTipoExame, nuIdade}],
		queryFn: async ({signal}) =>
			// 204 No Content has no body; React Query rejects undefined data
			(await getExamsPreparation({signal, cdTipoExame, nuIdade})) ?? null,
	});

export const useGetExamsPreparationQuery = ({
	cdTipoExame,
	nuIdade,
	enabled = true,
}: GetExamsPreparationParams) =>
	useQuery({
		...examsPreparationQueryOptions({cdTipoExame, nuIdade}),
		enabled: enabled && !!cdTipoExame && !!nuIdade,
	});
